import React from 'react';
import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../helpers';
import { AppContextProvider } from '../../Services/AppContext';
import { TreatmentContextProvider } from '../../Services/TreatmentContext';
import CaseChat from './CaseChat';
import { Provider } from 'react-redux';
import { store } from '../../store/store';

loadDOMComponent({
	selector: 'react-case-chat',
	callback: ({ container, context, props }: any) => {
		const userId = container.getAttribute('userId');
		const caseId = container.getAttribute('caseId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<TreatmentContextProvider
						values={{
							isTreatment: true,
							isCase: !!caseId,
							openMeddiDiabetes: false,
							openMedicalReport: false,
							setOpenMedicalReport: () => {},
							setOpenMeddiDiabetes: () => {},
							setIsTreatment: () => {},
							setIsCase: () => {},
						}}>
						<CaseChat userId={userId} caseId={caseId} />
					</TreatmentContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
